export default {
  rateSchedule: undefined,
};
